import { Divider, Icon } from '@design-system';
import React, { FC, ReactNode } from 'react';

import Drawer from '../../../Layout/Drawer';

interface DrawerModuleProps {
  buttonText: string | JSX.Element;
  drawer: ReactNode;
  suffix?: string | React.ReactElement;
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  preview: ReactNode;
  canOpen?: boolean;
}

export const DrawerModule: FC<DrawerModuleProps> = ({
  buttonText,
  canOpen = true,
  drawer,
  isOpen,
  onClose,
  onOpen,
  preview,
  suffix,
}) => (
  <>
    <div className="flex flex-col bg-white">
      {preview}
      {canOpen && (
        <>
          <Divider className="mt-4" />
          <button
            className="group mt-4 flex items-center justify-between transition-colors duration-300 hover:text-neutral-4"
            onClick={onOpen}
            type="button"
          >
            <span>{buttonText}</span>
            <span className="flex items-center gap-2">
              {suffix && <span>{suffix}</span>}
              <Icon name="ic_chevron_right" />
            </span>
          </button>
        </>
      )}
    </div>
    <Drawer onClose={onClose} shown={isOpen}>
      {isOpen && drawer}
    </Drawer>
  </>
);
